/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { registry } from '@/lib/page-designer/registry';

// STATIC_REGISTRY_START

const staticRegistryImporters = [
    () => import('../../components/announcement-banner/index'),
    () => import('../../components/content-card/index'),
    () => import('../../components/hero/index'),
    () => import('../../components/dynamic-image/index'),
    () => import('../../components/home/popular-category/index'),
    () => import('../../components/product-recommendations/index'),
    () => import('../../components/product-tile/index'),
    () => import('../../components/grid/index'),
    () => import('../../components/header/index'),
    () => import('../../components/hero-carousel/index'),
    () => import('../../components/navigation-menu-mega/index'),
    () => import('../../components/home/popular-categories/index'),
    () => import('../../components/product-carousel/index'),
    () => import('../../components/product-merchandising-grid/index'),
] as const;

/**
 * Initialize the static component registry.
 * This function is auto-generated by the staticRegistry Vite plugin.
 *
 * DO NOT EDIT THIS FUNCTION MANUALLY - it will be overwritten on next build.
 *
 * Components registered: Content.announcementBanner, Content.contentCard, Content.hero, Content.pdImage, Content.popularCategory, Content.productRecommendations, Content.productTile, Layout.grid, Layout.header, Layout.heroCarousel, Layout.megaMenu, Layout.popularCategories, Layout.productCarousel, Layout.productMerchandisingGrid
 */
export function initializeRegistry(targetRegistry = registry): void {
    targetRegistry.registerImporter('Content.announcementBanner', staticRegistryImporters[0], { fallback: 'fallback' });
    targetRegistry.registerImporter('Content.contentCard', staticRegistryImporters[1]);
    targetRegistry.registerImporter('Content.hero', staticRegistryImporters[2]);
    targetRegistry.registerImporter('Content.pdImage', staticRegistryImporters[3]);
    targetRegistry.registerImporter('Content.popularCategory', staticRegistryImporters[4], { loader: 'loader' });
    targetRegistry.registerImporter('Content.productRecommendations', staticRegistryImporters[5], { loader: 'loader' });
    targetRegistry.registerImporter('Content.productTile', staticRegistryImporters[6], { loader: 'loader' });
    targetRegistry.registerImporter('Layout.grid', staticRegistryImporters[7]);
    targetRegistry.registerImporter('Layout.header', staticRegistryImporters[8]);
    targetRegistry.registerImporter('Layout.heroCarousel', staticRegistryImporters[9], { fallback: 'fallback' });
    targetRegistry.registerImporter('Layout.megaMenu', staticRegistryImporters[10]);
    targetRegistry.registerImporter('Layout.popularCategories', staticRegistryImporters[11], { loader: 'loader' });
    targetRegistry.registerImporter('Layout.productCarousel', staticRegistryImporters[12], {
        loader: 'loader',
        fallback: 'fallback',
    });
    targetRegistry.registerImporter('Layout.productMerchandisingGrid', staticRegistryImporters[13], {
        loader: 'loader',
        fallback: 'fallback',
    });
}

// STATIC_REGISTRY_END
